// 签到领现金相关路由
export default {
  routes: [
    // 好友助力抬价页
    {
      path: '/(\\s*)friendbid(\\d*)/(\\s*)friend(\\d*)',
      name: 'friendbid-friend',
      meta: {
        auth: true,
        desc: '好友助力抬价页'
      },
      component: () =>
        import(/* webpackChunkName: "friendbid-friend" */ '../views/friendbid/friend/index.vue')
    }
  ]
}
